import { render, staticRenderFns } from "./PrintBill.vue?vue&type=template&id=51327486&scoped=true"
import script from "./PrintBill.vue?vue&type=script&lang=js"
export * from "./PrintBill.vue?vue&type=script&lang=js"
import style0 from "./PrintBill.vue?vue&type=style&index=0&id=51327486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51327486",
  null
  
)

export default component.exports